export default class Obj {
  static clone(o2) {
    let obj = undefined;
    if (Array.isArray(o2)) {
      obj = [];
      for (let val of o2) obj.push(Obj.clone(val));
    } else if (typeof o2 == "object") {
      obj = {};
      for (var key in o2) obj[key] = Obj.clone(o2[key]);
    } else {
      obj = o2;
    }
    return obj;
  }

  static complexObjClone(obj) {
    // Se obj è una Map
    if (obj instanceof Map) {
      const copyMap = new Map();
      obj.forEach((value, key) => {
        copyMap.set(key, this.complexObjClone(value));
      });
      return copyMap;
    }

    // Se obj è un Array
    if (Array.isArray(obj)) {
      return obj.map((item) => this.complexObjClone(item));
    }

    // Se obj è un oggetto
    if (typeof obj === "object" && obj !== null) {
      const copyObj = {};
      for (let key in obj) {
        if (Object.hasOwn(obj, key)) {
          copyObj[key] = this.complexObjClone(obj[key]);
        }
      }
      return copyObj;
    }
    return obj;
  }
}
